module.exports = __webpack_public_path__ + "img/logo-full-sm.cbfcde06.png";